<template>
  <div>
    <div class="mb-4">
      <h2>
        Не проверенные задания
      </h2>
      <div>
        <VueGoodTable
            :columns="columns"
            :rows="activeHomeworks"
        >
          <template slot="table-row" slot-scope="props">
         <span v-if="props.column.field === 'file'">
          <span>
            <a download="Домашнее задание" :href="props.row.file">Скачать файл</a>
          </span>
        </span>
            <span v-else-if="props.column.field === 'actions'">
          <b-button variant="primary" @click="evaluateLesson(props.row.id)">Оценить урок</b-button>
        </span>

            <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
          </template>

        </VueGoodTable>
      </div>
    </div>

    <div>
      <h2>
        Проверенные задания
      </h2>
      <div>
        <VueGoodTable
            :columns="columns"
            :rows="oldHomeworks"
        >
          <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'file'">
          <span>
            <a target="_blank" download="Домашнее задание" :href="props.row.file_name">Скачать файл</a>
          </span>
        </span>
            <span v-else-if="props.column.field === 'actions'">
          <b-button variant="primary" @click="evaluateLesson(props.row.id)">Оценить урок</b-button>
        </span>

            <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
          </template>

        </VueGoodTable>
      </div>
    </div>

    <b-modal id="modal-1" @ok="sendEvaluation" name="evaluateLesson">
      <div class="modal-wrapper">
        <div>
          <h2 class="mb-3 text-center"> Домашнее задание ученика - {{ activeHomework.email }} </h2>
          <a target="_blank" class="d-block text-center mb-2" download="Домашнее задание" :href="activeHomework.file">Скачать
            файл</a>
          <b-form-group>
              Поставьте оценку уроку
            <br>
              <v-select
                  v-model="grade"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :clearable="false"
                  :options="grades"
              />
          </b-form-group>
          <label class="w-100 d-block pb-3 mb-3">
            <p>Описание</p>
            <textarea v-model="description" class="form-control"></textarea>
          </label>

          <!--          <button @click="sendEvaluation" type="button">Оценить урок</button>-->
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions
import 'vue-good-table/dist/vue-good-table.css';
import {VueGoodTable} from 'vue-good-table';
import {createNamespacedHelpers} from 'vuex';
import {BButton, BFormGroup, BModal} from 'bootstrap-vue'
import vSelect from 'vue-select'

const {
  mapState,
  mapActions,
  mapGetters,
} = createNamespacedHelpers('teacher');

export default {
  name: 'homeworks',
  components: {
    BModal,
    VueGoodTable,
    BButton,
    vSelect,
    BFormGroup
  },
  data() {
    return {
      grades: [
        1, 2, 3, 4, 5
      ],
      columns: [
        {
          label: 'Файл',
          field: 'file',
        },
        {
          label: 'Почта ученика',
          field: 'email',
        },
        {
          label: 'Урок',
          field: 'lessonName',
        },
        {
          label: 'Оценка',
          field: 'grade',
        },
        {
          label: 'Описание',
          field: 'description',
        },
        {
          label: 'Действия',
          field: 'actions',
        },
      ],
      activeHomework: '',
      grade: '',
      description: '',
    };
  },
  methods: {
    showModal() {
      this.$root.$emit('bv::show::modal', 'modal-1')
    },
    ...mapActions(['getHomeworks', 'evaluateHomeWork']),
    evaluateLesson(id) {
      this.activeHomework = this.homeworks.find((homework) => homework.id === id);
      this.showModal()
    },
    sendEvaluation() {
      const options = {
        grade: this.grade,
        description: this.description,
        id: this.activeHomework.id,
      };
      this.evaluateHomeWork(options)
          .then(() => {
            this.$toast.success('Домашнее задание успешно проверено');
          })
          .catch(() => {
            this.$toast.error('Попробуйте проверить домашнее задание позже');
          })
          .finally(() => {
            this.$modal.hide('evaluateLesson');
          });
    },
  },
  computed: {
    ...mapGetters(['activeHomeworks', 'oldHomeworks']),
    ...mapState({
      homeworks: (state) => state.homeworks,
    }),
  },
  created() {
    this.getHomeworks();
  },
};
</script>

<style scoped>

</style>
